export default __webpack_public_path__ + "static/media/officialEN.1d2c9f75.jpg";